import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { awsInstance } from "../../actions/api";
import { useRecoilState } from "recoil";
import {
  userState,
  employeeListState,
  adminListState,
} from "../../stores/atoms";
import Loading from './../Loading';

function ModalForAdmin(props) {
  const [user] = useRecoilState(userState);
  const [adminName, setAdminName] = useState("");
  const [adminId, setAdminId] = useState("");
  const [employeeList, setEmployeeList] = useRecoilState(employeeListState);
  const [, setAdminList] = useRecoilState(adminListState);
  const [, setModalShow] = useState();
  const [loading, setLoading] = useState(false);

  const onResetData = () => {
    setAdminName("");
    setAdminId("");
  };

  const getEmployeeList = async () => {
    try {
      const { data } = await awsInstance.get("/business/employee-list", {
        params: {
          company_id: user.company_id,
        },
      });
      if (data.code === "SUCCESS") {
        const filteredList = data.data.filter(
          (value) => value.authorized === 0
        );
        setEmployeeList(filteredList);
      }
    } catch (e) {
      alert(e);
    }
  };

  useEffect(() => {
    if (props.show) {
      getEmployeeList();
      setModalShow(true);
    } else {
      setModalShow(false);
      onResetData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  useEffect(() => {
    getEmployeeList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSaveClick = async (authorized, id) => {
    if (!id || !authorized) {
      alert("지정할 관리자를 선택해주세요.");
      return false;
    }
    try {
      setLoading(true);
      const { data } = await awsInstance.post('business/admin/invitation', { id }); // 관리자 초대 API
      if (data.code != 'SUCCESS') {
        alert(data.message);
        return;
      }
      alert("관리자가 초대되었습니다. 이메일로 수락하면 관리자 지정이 완료됩니다.");
    } catch (e) {
      alert(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <span className="modal-title">관리자 지정</span>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="display-flex flex-content-around w-100 align-items-center">
              <p className="mr-1 width-20">관리자 권한</p>
              <select
                className="form-control mb-4 mt-4 width-70"
                value={adminName}
                onChange={(e) => setAdminName(e.target.value)}
              >
                <option value="">선택</option>
                <option value="1">관리책임자</option>
                <option value="2">운영담당자1</option>
                <option value="3">운영담당자2</option>
              </select>
              </div>
              <div className="display-flex flex-content-between w-100 align-items-center">
              <p className="mr-1 width-20">직원 지정</p>
              <select
                className="form-control mb-4 mt-4 width-70"
                value={adminId}
                onChange={(e) => setAdminId(e.target.value)}
              >
                <option value="">선택</option>
                {employeeList.map((employee, index) => {
                  return (
                    <option key={index} value={employee.id}>
                      {employee.name}
                      {employee.department ? `(${employee.department})` : ""}
                    </option>
                  );
                })}
              </select>
            </div>
            <span className="m-3 txt-gray text-left font-small">
              *관리책임자: 관리시스템의 서비스 이용을 총괄하는 임직원<br/>
              *운영담당자1: 관리시스템의 서비스 이용 총괄 업무를 대행하는 임직원<br/>
              (직원 관리 및 이용내역 조회 권한)<br/>
              *운영담당자2: 관리시스템의 서비스 이용 총괄 업무를 대행하는 임직원<br/>
              (이용내역 조회 권한)<br/>
            </span>
            <button
              className="btn-blue-md m-2 width-30"
              onClick={() => onSaveClick(adminName, adminId)}
            >
              저장
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <Loading loading={loading} />
    </>
  );
}

export default ModalForAdmin;
